import { ChangeEvent, useEffect, useState } from "react";
import { normalizeText } from "helpers/textHelpers";
import { labelHelper } from "helpers/themeHelpers";

function useFilterListByTerm<T>(
  items: T[],
  filterCb?: (filterTerm: string) => T[] | Promise<T[]>,
  resetFilter?: boolean
) {
  const [filterTerm, setFilterTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState(items);

  useEffect(() => {
    if (resetFilter) {
      setFilterTerm("");
      setFilteredItems(items);
    }
  }, [resetFilter, items]);

  function filterList(filterTerm: string) {
    return items?.filter((item) =>
      getSanitizedTerm(labelHelper(item))?.includes(getSanitizedTerm(filterTerm))
    );
  }

  useEffect(() => {
    if (filterCb && filterTerm?.length > 0) {
      const filterCbResult = filterCb(filterTerm);
      if (filterCbResult instanceof Promise) {
        filterCbResult
          .then((res) => setFilteredItems(res))
          .catch((err) =>
            console.log(`Error while filtering list of ${items}`, err)
          );
      } else {
        setFilteredItems(filterCbResult);
      }
    } else {
      setFilteredItems(filterList(filterTerm));
    }
    if(!filterTerm) setFilteredItems(items);
  }, [filterTerm, items, filterCb]);

  function onFilterTermChange(evt: ChangeEvent<HTMLInputElement>) {
    const newFilterTerm = getSanitizedTerm(evt.target.value);
    setFilterTerm(newFilterTerm);
    if (!newFilterTerm) {
      setFilteredItems(items);
    }
  }

  function getSanitizedTerm(label: string) {
    return normalizeText(label.toLocaleLowerCase());
  }

  return { filterTerm, onFilterTermChange, filteredItems };
}

export default useFilterListByTerm;
